import { useRef } from 'react';
import type { PopoverProps } from '@amzn/awsui-components-core/popover';
export const useStudioCompareMenu = (onSelect: (id: string) => void) => {
  const triggerRef = useRef<HTMLDivElement>(null);
  const popoverRef = useRef<PopoverProps.Ref>(null);
  const reveal = (): void => triggerRef.current?.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'auto' });
  const select = (id: string): void => {
    popoverRef.current?.focus();
    onSelect(id);
  };
  return { triggerRef, popoverRef, reveal, select };
};
